import gql from 'graphql-tag';

export const GET_PROGRAMME_GROUPS = gql`
  {
    programmeGroups
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/programme/groups.js